
export const GLOSSARY_TERMS = [
  {
    key: 'threshold',
    titleKey: 'glossary.threshold.title',
    bodyKey: 'glossary.threshold.body',
  },
  {
    key: 'race_pace',
    titleKey: 'glossary.race_pace.title',
    bodyKey: 'glossary.race_pace.body',
  },
  {
    key: 'mp_segment',
    titleKey: 'glossary.mp_segment.title',
    bodyKey: 'glossary.mp_segment.body',
  },
  {
    key: 'recovery',
    titleKey: 'glossary.recovery.title',
    bodyKey: 'glossary.recovery.body',
  },
  {
    key: 'easy_zone',
    titleKey: 'glossary.easy_zone.title',
    bodyKey: 'glossary.easy_zone.body',
  },
  {
    key: 'long_run_structure',
    titleKey: 'glossary.long_run_structure.title',
    bodyKey: 'glossary.long_run_structure.body',
  },
];